
import useTranslation from "./Hooks/UseTranslation";
import { PROJECTS_NAVIGATION } from "./Pages/HomePage/projects-navigation";
import { PROJECT_OVERVIEW_NAVIGATION } from "./Pages/App/Project/Home/project-overview-navigation";
import { PROGRAMMATION_NAVIGATION } from "./Pages/ProjectProgrammation/programmation-navigation";
import { TASKS_NAVIGATION } from "./Pages/ProjectTasksPage/tasks-navigation";
import { RESOURCES_NAVIGATION } from "./Pages/ProjectResources/resources-navigation";

type Submenu = {
    text: string;
    path: string;
    icon: string;
    active: boolean;
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
    requiresProject?: boolean;
    disabledReason?: 'project' | 'unavailable';
}

type Menu = {
    text: string;
    textWidth?: number;
    path: string;
    icon: string;
    active: boolean;
    submenu?: Submenu[];
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
    requiresProject?: boolean;
    disabledReason?: 'project' | 'unavailable';
}

type Navigation = [
    Menu[],
    Submenu[]
]

const getNavigation = (project_id: string, active_menu: string, active_submenu: string): Navigation => {

    const { t } = useTranslation()

    const projectPath = (path: string) => project_id ? `/project/${project_id}${path}` : '/'

    const applyAvailability = (item: any, parentRequiresProject = false): any => {
        const requiresProject = Boolean(item.requiresProject || parentRequiresProject)
        const projectBlocked = requiresProject && !project_id
        const unavailable = Boolean(item.disabled) && !projectBlocked

        return {
            ...item,
            requiresProject,
            disabled: Boolean(projectBlocked || unavailable),
            disabledReason: projectBlocked
                ? 'project'
                : unavailable
                    ? item.disabledReason || 'unavailable'
                    : undefined,
            submenu: item.submenu?.map((submenuItem: any) => (
                applyAvailability(submenuItem, requiresProject)
            )),
        }
    }

    const getShellMenu = () => [
        {
            text: 'Proyectos',
            path: `/`,
            icon: `icon-mis_proyectos`,
            active: active_menu === 'homepage',
            itemWidth: 126,
            submenu: PROJECTS_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: tab.path,
                icon: tab.icon,
                active: active_menu === 'homepage' && active_submenu === tab.id,
            })),
        },
        {
            text: t('NAVIGATION:Start'),
            path: projectPath('/'),
            icon: `icon-dashboard`,
            active: active_menu === 'start' || active_menu === 'home',
            requiresProject: true,
            itemWidth: 102,
            submenu: PROJECT_OVERVIEW_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: projectPath(tab.path),
                icon: tab.icon,
                active: active_submenu === tab.id,
            })),
        },
        {
            text: t('NAVIGATION:Teams'),
            path: projectPath('/teams'),
            icon: `icon-equipos`,
            active: active_menu === 'teams',
            requiresProject: true,
            itemWidth: 116,
        },
        {
            text: t('NAVIGATION:Programmation'),
            path: projectPath('/programmation-macro'),
            icon: `icon-programacion`,
            active: active_menu === 'programmation',
            requiresProject: true,
            itemWidth: 154,
            submenu: PROGRAMMATION_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: projectPath(tab.path),
                icon: tab.icon,
                active: active_submenu === tab.id,
                itemWidth: tab.itemWidth,
            })),
        },
        {
            text: t('NAVIGATION:Tasks'),
            path: projectPath('/tasks'),
            icon: `icon-tareas`,
            active: active_menu === 'tasks',
            requiresProject: true,
            itemWidth: 112,
            submenu: TASKS_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: projectPath(tab.path),
                icon: tab.icon,
                active: active_submenu === tab.id,
            })),
        },
        {
            text: t('NAVIGATION:Resources'),
            path: projectPath('/resources/restrictions'),
            icon: `icon-recursos`,
            active: active_menu === 'resources',
            requiresProject: true,
            itemWidth: 124,
            submenu: RESOURCES_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: projectPath(tab.path),
                icon: tab.icon,
                active: active_submenu === tab.id,
            })),
        },
        {
            text: 'BIM',
            path: `/`,
            icon: `icon-recursos`,
            active: false,
            disabled: true,
            itemWidth: 86,
        },
        {
            text: 'Protocolos',
            path: `/`,
            icon: `icon-tareas`,
            active: false,
            disabled: true,
            itemWidth: 130,
        },
        {
            text: 'Configuración',
            path: `/profile`,
            icon: `icon-configuracion`,
            active: active_menu === 'profile',
            itemWidth: 154,
            alignRight: true,
        },
    ]

    const menu = getShellMenu().map((item) => applyAvailability(item))
    const submenu = project_id
        ? menu.find((item: any) => item.active)?.submenu || []
        : []

    return [ menu, submenu ]
}

export default {
    getNavigation,
}
